export default __webpack_public_path__ + "static/media/2.820e9fe9.jpg";